import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from './user/user.service';
import { PlatformLocation } from "@angular/common";
import { DataService } from './core/data';
import { Router } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    providers: [
        UserService
    ],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  loadingText: string;
  subscription: Subscription;
  screenAccess: any = {};
  dashAccess =  false;
  salesRepAccess = false;
  fileUploadAccess = false;
  reportsAccess = false;
  commissionAccess = false;

  show2FAMessage = true;
  constructor(
    private platformLocation: PlatformLocation,
    private _data: DataService,
    private router: Router 
  ){
    this._data.currentText$.subscribe(loadingText => {
      this.loadingText = loadingText;
    });
    this.platformLocation.onPopState(() => {
      window.location.reload();
    })
  }
  ngOnInit() {}

  isLoginPage(): boolean {
   return this.router.url.includes('login');
  }
  
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}